import { CommonModule } from '@angular/common';
import { Component, TrackByFunction, inject } from '@angular/core';
import { map } from 'rxjs';
import { LoaderService } from '../../../services/loader.service';
import { DauerService } from '../../../services/facetten/instance/dauer.service';
import { sortFilterItems } from '../../../shared/utils/sort-fillter-items.util';
import { FilterSelectItem } from '../../checkbox-facette/checkbox-liste/filterSelectItem';
import { BasisFacetteComponent } from '../basis-facette/basis-facette.component';

@Component({
  selector: 'now-wbsuche-lib-dauer-facette',
  templateUrl: './dauer-facette.component.html',
  imports: [BasisFacetteComponent, CommonModule],
  styleUrls: ['dauer-facette.component.scss']
})
export class DauerFacetteComponent {
  facettenService = inject(DauerService);
  loaderService = inject(LoaderService);

  public expanded$ = this.facettenService.expanded$;
  public items$ = this.facettenService
    .getSelectItems$()
    .pipe(map((filterList) => sortFilterItems(filterList)));

  trackById: TrackByFunction<FilterSelectItem> = (_, { key }) => key;

  public updateSelectedIds(selectedIds: string): void {
    this.facettenService.updateSelectedIds(selectedIds.split(','));
  }
}
